/**
 *@author fangqiwei
 *年份控件
 */

import Component from '../../../lib/component'
import template from './year-month-control.html'
import {AutoSelect} from "../../util/autoSelect/autoSelect"
import WXtemplate from './year-month-control.wx.html'
import BaseControl from '../WXbase-control/WXbase-control';

let config={
    template:template,
    data:{
        isInit:true,
    },
    binds:[
        {
            event: 'click',
            selector: '.ui-history',
            callback: function(){
                this.events.emitHistory(this.data);
            }
        }
    ],
    actions:{
      changeValue(value,_this){
          let val = 0;
          if( value > 12 ){
              val =value + "-" + _this.data.value.split('-')[1];
          }
          else{
              val = _this.data.value.split('-')[0] + "-" + value;
          }
          _this.data.value = val;
          _.debounce(function(){_this.events.changeValue(_this.data)},200)();
      },
	  init(){
		  let _this=this;
		  let yearData = {
			  multiSelect:false,
			  editable:this.data.is_view?false:true,
			  onSelect:function(data){
				  if(data.length==0 || _this.data.isInit){
					  return;
				  }
				  _this.actions.changeValue(data[0]['id'],_this);
			  },
			  choosed:[],
		  } ;
		  let monthData = {
			  multiSelect:false,
			  editable:this.data.is_view?false:true,
			  onSelect:function(data){
				  if(data.length==0 || _this.data.isInit){
					  return;
				  }
				  _this.actions.changeValue(data[0]['id'],_this);
			  },
			  choosed:[],
		  } ;
		  let myDate = new Date();
		  let myYear = myDate.getFullYear();
		  if(!yearData.list || !yearData.list.length){
			  yearData.list=[];
		  }
		  yearData.list.push({ "name": String(myYear),"id": String(myYear)})
		  for( let i=1;i<=5;i++ ){
			  yearData.list.unshift( { "name": String(myYear - i),"id": String(myYear - i)} );
			  yearData.list.push( { "name": String(myYear + i),"id": String(myYear + i)} );
		  }
		  monthData.list = [
			  {"name": 1,"id": '01'},
			  {"name": 2,"id": '02'},
			  {"name": 3,"id": '03'},
			  {"name": 4,"id": '04'},
			  {"name": 5,"id": '05'},
			  {"name": 6,"id": '06'},
			  {"name": 7,"id": '07'},
			  {"name": 8,"id": '08'},
			  {"name": 9,"id": '09'},
			  {"name": 10,"id": 10},
			  {"name": 11,"id": 11},
			  {"name": 12,"id": 12}
		  ]
		  if(this.data.value != ''){
			  yearData['choosed'][0] = {name:this.data.value.split('-')[0],id:this.data.value.split('-')[0]};
			  monthData['choosed'][0] = {name:this.data.value.split('-')[1],id:this.data.value.split('-')[1]};
			  // if (this.data.is_view) {
				  this.el.find('.year').attr('title', yearData['choosed'][0].name);
				  this.el.find('.month').attr('title', monthData['choosed'][0].name)
			  // }

		  }
		  else{
			  yearData['choosed'][0] = {name:myYear,id:myYear};
			  monthData['choosed'][0] = {name:myDate.getMonth() + 1,id:myDate.getMonth() + 1};
			  let myMonth=(myDate.getMonth() + 1)<10?'0'+(myDate.getMonth() + 1):(myDate.getMonth() + 1);
			  let val = myYear+'-'+myMonth;
			  _this.data.value = val;
			  _.debounce(function(){_this.events.changeValue(_this.data)},200)();
		  }
		  this.destroyChildren();
		  this.append(new AutoSelect({data:yearData}),this.el.find('.year'));
		  this.append(new AutoSelect({data:monthData}),this.el.find('.month'));
		  this.data.isInit=false;
	  },
	  iconCheck(){
		  if(this.data.history){
			  this.el.find('.ui-history').css('visibility','visible');
		  }
	  }
    },
    afterRender(){
       this.actions.iconCheck();
       this.actions.init();
    },
    beforeDestory(){
        this.el.off();
    }
}
let YearMonthControl = Component.extend(config)
export default YearMonthControl;

let WXconfig={
	data:Object.assign({},config.data,{controlHtml:WXtemplate}),
	actions:Object.assign({},config.actions,{
		changeValue(value,_this){
			let val = 0;
			if( value > 12 ){
				val =value + "-" + _this.data.value.split('-')[1];
			}
			else{
				val = _this.data.value.split('-')[0] + "-" + value;
			}
			_this.data.value = val;
		},
	}),
	afterRender(){
		this._super.afterRender();
		this.actions.init();
	}
}
let YearMonthControlWX=BaseControl.extend(WXconfig);
export {YearMonthControlWX}


// WEBPACK FOOTER //
// app/components/form/year-month-control/year-month-control.js